// Lazy load function
const lazyLoad = (file) => () =>
  import(/* webpackChunkName: "[request]" */ `@/views/production/${file}.vue`);

export default [
  {
    path: "/production-schedule",
    name: "production-schedule",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ProductionSchedule",
    },
    components: {
      content: lazyLoad("production-schedule"),
    },
  },
  {
    path: "/work-order-material-availability-status",
    name: "work-order-material-availability-status",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "WorkOrderMaterialAvailabilityStatus",
    },
    components: {
      content: lazyLoad("work-order-material-availability-status"),
    },
  },
  {
    path: "/work-order-material-availability-status/review/:id",
    name: "work-order-material-availability-status-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "WorkOrderMaterialAvailabilityStatus",
    },
    components: {
      content: lazyLoad("work-order-material-availability-status"),
    },
  },
  {
    path: "/work-order-material-availability-status/edit/:id",
    name: "work-order-material-availability-status-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "WorkOrderMaterialAvailabilityStatus",
    },
    components: {
      content: lazyLoad("work-order-material-availability-status"),
    },
  },
  {
    path: "/sales-awaiting-planning",
    name: "sales-awaiting-planning",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "SalesOrderPlanning",
    },
    components: {
      content: lazyLoad("sales-awaiting-list"),
    },
  },
];
